module.exports = __webpack_public_path__ + "media/attorney_resource_center/litigation-finance-book-d07ed907.png";